export const GENERAL_QUERY_KEYS = {
  SOCIAL: [ 'general', 'social' ],
  SEARCH: [ 'general', 'search', 'handler' ],
  BANNER: [ 'general', 'banner' ],
  EXPLORER: [ 'general', 'explorer' ],
  HOME_BANNER: [ 'general', 'home', 'banner' ],
}